var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-right pr-2 mr-2"},[_vm._m(0),_c('br'),_c('strong',[_c('span',[_vm._v(" "+_vm._s(_vm.$store.getters.usuario.ultimoAcesso && _vm.$store.getters.usuario.ultimoAcesso !== '' ? _vm.$moment(_vm.$store.getters.usuario.ultimoAcesso).format( 'DD/MM/YYYY HH:mm' ) : '')+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('small',[_vm._v("Último Acesso")])])
}]

export { render, staticRenderFns }